import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-887">
      <HeroSection data-id="element-888" />
      <PainSection data-id="element-889" />
      <TruthSection data-id="element-890" />
      <ProductPresentation data-id="element-891" />
      <ContentBreakdown data-id="element-892" />
      <BenefitsSection data-id="element-893" />
      <TestimonialsSection data-id="element-894" />
      <ForYouSection data-id="element-895" />
      <GuaranteeSection data-id="element-896" />
      <BonusSection data-id="element-897" />
      <ValueStack data-id="element-898" />
      <FAQSection data-id="element-899" />
      <ImpactPhrases data-id="element-900" />
      <Footer data-id="element-901" />
    </div>;
}